import { storefrontPeaceOfMindRetestPartTwoSelector } from '@redux/experiments/selectors/storefront-peace-of-mind-retest-part-two';
import { useAppSelector } from '@redux/hooks';

export const useStorefrontPeaceOfMind = () => {
	const retestAssignment = useAppSelector(
		storefrontPeaceOfMindRetestPartTwoSelector,
	);

	return retestAssignment === 'variant1';
};
